/* eslint-disable camelcase */

export default {

	// ===================================================================
	// common
	// ===================================================================
	common: {
		action: "Åtgärd",
		actions: "Åtgärder",
		all: "Alla",
		annat: "Annat",
		answer: "Svar",
		arEnbart: "{0} år",
		arFormat: "{0} år",
		arGammel: "{0} år gammel",
		arOch: "{0} år och {1} mån",
		arOchManader: "{0} år och {1} månader",
		areyousure: "Är du säker?",
		arskurs: "Årskurs",
		arskursNum: "{0}. Årskurs",
		arsskrivformat: "ÅÅÅÅ-MM-DD",
		arbetsminne: "Arbetsminne",
		arbetsminne_ord: "Arbetsminne (Ord)",
		arbetsminne_tal: "Arbetsminne (Tal)",
		bokstavkunnskap: "Bokstavkunnskap",
		boy: "Pojke",
		bytaljud: "Bytaljud",
		cancel: "Avbryt",
		chooselanguage: "Välj språk",
		clear: "Clear",
		clickToSelectDate: "Klicka för att välja datum",
		completed: "Genomfört",
		confirm: "Bekräfta",
		correct: "Korrekt",
		country: "Land:",
		date: "Datum",
		delete: "Radera",
		duHarIkkeValgtNoe: "Du har inte valt något!",
		dysmateLogoAlt: "Dysmate",
		edit: "Redigera",
		email: "E-post",
		enMinutsOrdavkodning: "En minuts ordavkodning",
		error: "Error",
		errorhasoccured: "Ett fel har inträffat",
		ettminuttstest: "Ettminuttstest",
		fel: "Fel",
		female: "Kvinna",
		fetch: "Återställ",
		firstname: "Förnamn",
		fodd: "Född",
		fonembyte: "Fonembyte",
		fonemisolation: "Fonemisolering",
		from: "Fra:",
		fullname: "Fullständigt namn",
		gender: "Kön",
		girl: "Flicka",
		grade: " Årskurs",
		handbok: "Handbok",
		hiddenname: "<Dolt namn>",
		hideWithArrow: "Dölj ▲",
		ikeFunnet: "Hittades inte:",
		inProgress: "In progress",
		inactive: "Inaktiv",
		insert: "Infoga",
		inteTillganglig: "Inte tillgänglig",
		ja: "Ja",
		kon: "Kön",
		language: "Språk",
		lasforstaelse: "Läsförståelse",
		lastname: "Efternamn",
		leggTil: "Lägg till",
		letterknowledgetest: "Bokstavskunskap",
		literateLogoAlt: "Literate logo",
		male: "Man",
		manaderFormat: "{0} månader",
		message_incompletData: "Ogiltig eller ofullständig uppgift",
		mypage: "Min sida",
		name: "Namn:",
		namn: "Namn",
		nei: "Nej",
		nej: "Nej",
		nonwordtest: "Nonsensord",
		nonsensord: "Nonsensord",
		normalDistributionAlt: "Graph with normal distribution chart",
		notCompleted: "Inte genomfört",
		notavailable: "ej tillgänglig",
		nr: "Nr",
		oneminute: "1-minuts ordavkodning",
		oneminutetest: "Enminutstest",
		oppsSomethingWentWrong: "Ops! something went wrong.",
		ordforstaelse: "Ordförståelse",
		ordkedjor: "Ordkedjor",
		organization: "Organisation",
		ospecificerat: "Ospecificerat",
		other: "Other",
		over: "över",
		percentil: "Percentil",
		percentilescore: "Percentilpoäng",
		phonemeomissiontest: "Fonemsubtraktion",
		phonemisolationtest: "Fonemisolation",
		placeholderEmail: "\"kari@nordmann.no\"",
		placeholderFirstName: "Kari",
		placeholderFirstNameSv: "Namn",
		placeholderLastName: "Nordmann",
		placeholderLastNameSv: "Namnsson",
		placeholderOrganization: "Kongsbakken vgs",
		placeholderPhone: "+46 70 123 45 67",
		placeholderPhoneNumber: "987 65 432\"",
		pleaseTryAgainLater: "Please try again later.",
		points: "Poäng",
		providevalidname: "Ange ett giltigt namn",
		question: "Fråga",
		rapidautonamingtest: "Snabb automatiserad benämning",
		rapoang: "Rå poäng",
		rawscore: "Rå poäng",
		readingtest: "Läsförståelse",
		reason: "Årsaken",
		recommended: "anbefalt",
		removefiltering: "Ta bort filter",
		required: "Obligatorisk",
		resend: "Skicka igen",
		result: "Resultat",
		results: "Resultat",
		save: "Spara",
		scaledscore: "Skalpoäng",
		searchhere: "Sök här...",
		send: "Send",
		sex: "Kön",
		showingXofY: "Visar {0} / {1}",
		skrivflyt: "Skrivflyt",
		snabbAutomatiseradBenamning: "Snabb automatiserad benämning",
		sok: "Sök",
		sokHer: "Sök här...",
		somthingWentWrong: "Hoppsan! Något gick fel.",
		spoonerism: "Spoonerismer",
		spoonerismer: "Spoonerismer",
		spoonerismtest: "Spoonerism",
		standardpoang: "Standardpoäng",
		started: "Påbörjat",
		status: "Status",
		stavning: "Stavning",
		subject: "Ämne",
		success: "Suksess!",
		swapsoundtest: "Byt ljud",
		telephone: "Telefon",
		testdate: "Testdatum",
		tests: "Tester",
		theagegroup: "åldersgrupp",
		timeused: "Tid använd",
		to: "Til:",
		tpoang: "T-poäng",
		tscore: "T-poäng",
		type: "Typ",
		typingspeedtest: "Skrivflyt",
		uautorisert: "Oauktoriserad:",
		under: "under",
		usersupport: "Användarstöd",
		uspesifisert: "Uspesifisert",
		vetInte: "Vet inte",
		wordchaintest: "Ordkedjor",
		wordcomprehensiontest: "Ordförståelse",
		worddictationtest: "Stavning",
		wordsperminute: "ord per minut",
		workingmemorytest: "Arbetsminne",
		wrong: "Fel",
		zpoang: "Z-poäng",
		zscore: "Z-poäng",
		ratt: "Rätt",
		age: "Ålder",
		continue: "Fortsett",
	},

	// ===================================================================
	// auth
	// ===================================================================
	auth: {
		adminpersonalinformation: "Personuppgifter",
		bankid: "BankID",
		bankidonmobile: "Mobilt BankID",
		bekraftaInloggningsmetod: "Du måste först bekräfta din inloggningsmetod. Klicka på Personlig information när du blir omdirigerad.",
		byttIdentifiseringsmetode: "Du har nå valgt å bytte til en annet identifiseringsmetode. Vennligst start med å identifisere deg selv. Husk å bruke samme metode som du bruker for å logge på.",
		byttTilFeide: "Byt till FEIDE",
		chageToPassword: "Ja, jeg ønsker å bytte til Passord ",
		changeToFeide: "Ja, jeg ønsker å bytte til Feide ",
		confirmpassword: "Bekräfta lösenord",
		constTestChild: "Som testledare bekräftar du att du har erforderligt samtycke från testkandidaten för att samla in personuppgifter och att dessa används enligt beskrivning dysmates {0}",
		constTestYouth: "Som Testadministrator så bekrefter du at du har nødvendig samtykke fra Testkandiaten til å innhente personopplysninger og at disse brukes som beskrevet i Literates {0}",
		errorLoggingYouIn: "There was an error logging you in",
		feide: "Feide",
		glomtLosenordet: "Glömt lösenordet?",
		iConsent: "Jag bekräftar:",
		info_for_professional_with_either_completed_screening_test: "Detta är för yrkesverksamma som slutfört eller är anmälda till en certifieringskurs och som vill prova några tester innan de tecknar abonnemang.",
		info_prerequisites_to_obtain_license: "För att få tillgång till provperioden måste du anmäla dig till eller ha slutfört dysmate-certifieringskursen. Alla användare kommer att godkännas manuellt av Dysmate, varefter de kommer att få instruktioner i ett e-postmeddelande för att slutföra sin registrering för att få tillgång.",
		info_registration_eamil_sent: "Flott! Vi har nå sendt deg en registreringslenke på e-posten du oppga.",
		kunneIkkeLoggeInn: "Kunde inte logga in!",
		linkExpired: "Länken har gått ut",
		linkForInstructions: " Her",
		loggInnMedBankID: "Logga in med BankID",
		loggInnMedFeide: "Logga in med Feide",
		loggout: "Logga ut",
		login: "Logga in",
		loginmethod: "Inloggningsmetod",
		loginmethod_change_description: "Din nuvarande {0} är [{1}] Vill du ändra inloggningsmetod? (Rekommenderas)",
		loginmethods: "Inloggningsmetoder",
		loginwithbankid: "Logga in med följande metoder",
		losenord: "Lösenord",
		losenordetHarAndrats: "Lösenordet har ändrats",
		message_change_loginmethod: "Du är på väg att ändra din inloggningsmetod. Du kommer fortsätta behöva logga in med denna metod.",
		message_confirmation: "Dette vil sende en bekreftelse til brukerens epost, og gi brukeren tilgang til å begynne prøveperiode.",
		message_first_login: "Om du aldrig har loggat in tidigare på {0}, måste du slutföra din registrering.",
		message_initial_approval: "Vi har godkänt dig baserat på den e-postadress du angav när du deltog i certifieringskursen.",
		message_not_yet_approved: "Vi hittar inga godkända testadministratörer med den e-postadress du angav. Detta kan bero på att vi ännu inte har godkänt dig som testadministratör. Detta tar vanligtvis 1-3 dagar efter att man anmält sig till kursen.",
		message_provide_email: "Ange denna e-postadress i fältet nedan, så skickar vi dig registreringslänken.",
		message_thisisforcertifieduser: "Detta är för certifierade testadministratörer med prenumeration.",
		message_trial_period_expired: "Din provperiod har löpt ut. Kontakta oss för att teckna ett abonnemang.",
		message_try_loggin_in: "Det verkar som om du redan har slutfört din registrering. Logga in {0}.",
		message_user_already_registered: "Det verkar som om du redan har slutfört din registrering. Logga in med {0} {1}.",
		message_user_not_found: "Vi hittar inga kursdeltagare med den e-postadress du angav. Detta kan bero på att du använde en annan e-postadress när du registrerade dig för certifieringskursen.",
		myinformation: "Mina personuppgifter",
		newloginmethod: "Ny inloggningsmetod",
		nyLankSkickad: "Vi har skickat en ny länk till din e-postadress. Följ den nya länken för att återställa ditt lösenord.",
		nyckelFinnsInte: "finns inte. Prova länken som skickades till din e-post.",
		nyckelRedanAnvant: "är redan använt. Försök att logga in på",
		nyttLosenord: "Nytt Lösenord",
		onlytwotestspertrialperiod: "Endast 2 tester är tillgängliga under provperioden",
		password: "Lösenord",
		passwordStrength: "Strength",
		passwordTooltipLong: "Minimum of 7 characters. Should have at least One Capital letter, one small letter, one special character and one number.",
		passwordTooltipShort: "Minimum of 7 characters. One Capital and one small. Should have at least one special character and one number.",
		passwrodchanged: "Passord endret",
		personalinformation: "Personuppgifter",
		privacyPolicy: "integritetspolicy",
		referalgroups: "gruppmedlemskap",
		referalinformation: "personuppgifter",
		registrera: "Registrera",
		registreraDig: "Registrera dig",
		reminder_bankidmobileregistration: "Vi anbefaler at du registrer deg selv med Feide. Hvis du registrerer deg med Bank-ID på Mobil, må du også bruke Bank-ID på Mobil for å logge inn til tjenesten videre.  Vil du fortsette uansett?",
		reminder_bankidregistration: "Vi anbefaler at du registrer deg selv med Feide. Hvis du registrerer deg med Bank-ID, må du også bruke Bank-ID for å logge inn til tjenesten videre.  Vil du fortsette uansett?",
		resendCodeInSeconds: "Send koden på nytt om {0} sekunder.",
		resetpswlinksent: "Vi har sendt en ny lenke til dinepostadresse. Vennligst følge den ny linke for å tilbakestille en ny passord.",
		shcool_or_company: "Skola/företag",
		skapa: "Skapa",
		studentID: "Student-ID",
		testadminFinnsRedan: "En testadministratör med denna e-postadress finns redan. Försök att logga in istället.",
		trialperiod: "Provperiod",
		trialperiodexpired: "Provperioden har löpt ut",
		trialperiodinprogress: "Provperiod pågår",
		trialuser: "Provanvändare",
		unableToChangeLoginMethod: "Unable to change login Method: Error::",
		upgradetofullsubscription: "uppgradera till full prenumeration för att utfärda nya test.",
		upgradeyoursubscription: "Uppgradera din prenumeration",
		valjStarktLosenord: "Välj ett starkt lösenord.",
		verifieringskodSkickad: "Vi har skickat en verifieringskod till din e-postadress. Vänligen ange koden i fältet och tryck på 'Skicka'.",
		warning2: "Advarsel 2",
		warning2text: " - Det ser ut til at du har deaktivert sporing på tvers av nettsteder i nettleseren din. Dette er nødvendig for å bruke Dysmate dysleksitester. ",
		warning_text_end: " er en oppskrift for hvordan du skrur dette på.",
		yourtrialperiodhasexpired: "Din provperiod har tagit slut",
	},

	// ===================================================================
	// testManagement
	// ===================================================================
	testManagement: {
		addtesttogroup: "Lägg till test till en grupp",
		adult: "Vuxen",
		adultfollowup: "Dysmate-A II (Uppföljning vuxen)",
		adultfollowuptest: "Dysmate-A II (Uppföljningstest vuxen)",
		adultscreening: "Dysmate A – (Screeningtest för vuxna)",
		adulttests: "Dysmate-A (Vuxentest)",
		allReasons: "All reasons",
		allmytests: "Alla mina tester",
		allInvoiceStates: "Alla fakturastatusar",
		barnscreening: "Dysmate - C (Screeningtest for barn)",
		basis: "Basic",
		bibliotek: "Bibliotek",
		childfollowuptest: "Uppföljning barn",
		childnorming: "Normering barn",
		childscreening: "Dysmate-C (Screeningtest)",
		childtest: "Dysmate-C (Barntest)",
		childtests: "Dysmate-C (barntest)",
		completedtests: "Genomförda tester",
		completeplural: "Genomförda:",
		completiondate: "Genomfört datum",
		create_tests: "Skapa nya test",
		createnewtest: "Skapa nytt test",
		deletedByUser: "Deleted by user",
		deletedon: "Raderade",
		deletedtests: "Raderade test",
		deleteoldtests: "Radera gamla test",
		deleteall: "Radera alla",
		distribuertIkkeFullfort: "Distribuerad/ej slutförd",
		distributed: "Distribuerat",
		duHarIngenTester: "Du har ingen < {0} > tester",
		dysmateScreeningtest: "Dysmate - Screeningtest",
		dysmateScreeningtestBarn: "Dysmate - C Screeningtest för barn",
		dysmateScreeningtestUngdomar: "Dysmate - Screeningtest för ungdomar",
		dysmateScreeningtestVuxna: "Dysmate - Screeningtest för vuxna",
		dysmateYLasforstaelsetext: "Dysmate - Y Läsförståelsetext",
		experimentalchildtest: "Experimentellt barntest",
		expired: "Upphörd",
		expiresIn: "Upphör om {0}",
		followUpTest: "Uppföljningstest",
		followup: "Uppföljning",
		ikkebrukt: "Inte använd",
		logg: "Händelselogg",
		message_noTestsFound: "Du har inga raderade tester",
		message_testcannotbedeleted: "Testet måste vara minst 3 månader gammalt för att raderas.",
		myCandidates: "Mina Kandidater",
		mytest: "Mina tester",
		no_tests_available_message: "Du har inga tester.",
		norming: "Normering",
		notdistributed: "Inte distribuerad",
		notstarted: "Inte startat",
		okantDatum: "Okänt datum",
		olderThan3Years: "Older than 3 years",
		oppfolgingstester: "Uppföljningstester",
		paneMessageContinueTest: "Detta kommer skicka ut en ny länk till testet så att kandidaterna kan fortsätta ett ofullständig test. Fortsätt?",
		pincode: "Pinkod",
		recipient: "Mottagare",
		restartOrViewResults: "Choose to restart test or view results",
		screening: "Screening",
		screeningAlle: "Screening (alle)",
		screeningTest: "Screeningtest",
		screeningTestBarn: "Screeningtest (Barn)",
		screeningTestUngdom: "Screeningtest (Ungdom)",
		screeningtest: "Screeningtest",
		screeningtest_adult: "Dysmate-A (screeningtest vuxen)",
		searchByTestKey: "Sök Test nyckel",
		seeresults: "Se resultat",
		seetests: "Se test",
		sendcodeemail: "Skicka kod via email",
		sendtest: "Skicka test",
		seTestsSearchPlaceholder: "Search name / key / teacherId / token…",
		showpincode: "Visa PIN-kod",
		showtests: "Visa tester ▼",
		skrivTestnyckel: "Skriv testnyckel...",
		starttest: "Starta Test",
		test_type: "Testtyp",
		testDeleted: "Testet har raderats",
		testdeletedbyuser: "Testen ble slettet av brukeren",
		testkey: "Testnyckel",
		testledare: "testledare.",
		testolderthan3years: "testen er eldre enn 3 år",
		trashcan: "Papperskorg",
		uppfoljningAlle: "Uppföljning (alle)",
		uppfoljningstest: "Uppföljningstest",
		uppfoljningstestUngdom: "Uppföljningstest (Ungdom)",
		uppfoljningstestVuxen: "Uppföljningstest (Vuxen)",
		uppfoljningstester: "Uppföljningstester",
		used: "Använda:",
		usedon: "Brukt på",
		viewdeleted: "Raderade test ▼",
		warning_deleteAllTest: "Dette vil slette alle valgte testene permanent. Fortsett uansett?",
		warning_deleteSingleTest: "Dette vil slette testen permanent. Fortsett uansett?",
		warning_deletetest: "Testet kommer inte längre vara tillgängligt för bedömning. Vill du fortsätta?",
		youth: "Ungdom",
		youthfollowup: "Uppföljningstest (ungdom, åk 7-9)",
		youthfollowuptest: "Uppföljningstest (ungdom, åk 7-9)",
		youthscreening: "Dysmate-Y – (Screeningtest för ungdomar)",
		youthtests: "Dysmate-Y (Ungdomstest)",
		PINKOD: "Pinkod",
		bekräftaAttDuVillSkapaNyttTest: "Bekräfta att du vill skapa nytt test för de valda kandidaterna.",
		numberoftests: "Antal test (max 30)",
	},

	// ===================================================================
	// candidates
	// ===================================================================
	candidates: {
		FornavnEtternavn: "Förnamn, Efternamn",
		arbetsforberedelseTraning: "Arbetsförberedande träning",
		bachelor: "Kandidatexamen",
		birthDate: "Födelsedatum",
		bulkSending: "Massutskick",
		candidateBirthDate: "Födelsedatum",
		candidateEmail: "E-post (valbart*)",
		candidateFirstName: "Förnamn",
		candidateGender: "Kön",
		candidateGrade: "Årskurs",
		candidateInfoCommon: "Testkandidaten går till www.dysmate.se → \"TA TESTEN\".",
		candidateInfoReminder: "Observera att pinkoden också är tillgänglig på testledarsidan under <<Mina tester>>.",
		candidateLastName: "Efternamn",
		choosecandidate: "Välj en kandidat",
		createAndSend: "Skapa och skicka",
		createanddistributetests: "Om du vill skick många tester på samma gång kan du klistra in e-postadresser i fältet här och trycka på \"Skapa och skicka\".",
		dateofbirth: "Födelsedatum:",
		dessaKandidaterKommerAttFaDetNyaTestet: "Dessa kandidater kommer att få det nya testet",
		detErIkkeTillat: "Det är inte tillåtet att ändra något för det valda alternativet",
		detSerUtTilatDuIkkeHarIngenKandidaterForDetValgteValget: "Det ser ut til at du ikke har ingen kandidater for det valgte valget",
		doktorsexamen: "Doktorsexamen (PhD)",
		education: "Utbildning",
		educationagegroup: "Utbildning / åldersgrupp",
		ettSprak: "Ett språk",
		fillKandidateInformation1: "\n\tTestledaren fyller i testkandidatens uppgifter innan denne loggar in för att göra testet. Detta rekommenderas för de yngre årskurserna. Kandidaten kommer då snabbt igång med testet och kan logga in med pinkod.",
		fillKandidateInformationSelf1: "Detta gör det möjligt att skicka ut testet direkt via e-post till kandidaten. Kandidaten behöver då logga in och fylla i sina uppgifter (namn, kön, födelsedatum och årskurs).",
		fillKandidateInformationSelf2: "Detta passa vanligtvis för äldre elever i mellanstadiet som har tillgång till egen e-post adress.",
		fillOutInfo: "Fyll i information",
		fillSelfCandidateInfo: "Testledare fyller i kandidatens uppgifter",
		fleraSprak: "Flera språk",
		flereSprak: "Flere språk",
		fodelsedatumStammerInte: "Födelsedatum stämmer inte",
		gotoDysmtateSite: "Gå till www.dysmate.se",
		gradeDropDown: "-Välj årskurs-",
		gymnasieskola: "Gymnasieskola",
		harAnnatModersmal: "Har testkandidaten ett annat modersmål än svenska?",
		harVokstOpp: "Har vokst opp i ett- eller to-språklig hjem?",
		hjemmesprak: "Hjemmespråk",
		hogstadieskola: "Högstadieskola",
		homeLanugage: "Modersmål",
		instruktionerForKandidatinfon: "Instruktioner för kandidatinformationen",
		kandidater: "Kandidater",
		kandidatexamen: "Kandidatexamen",
		kandidatinfoOppdatert: "Kandidatinfo uppdaterad",
		klassetrinn: "Klassetrinn:",
		kommunLabel: "Kommun:",
		lageOpplysninger: "Lägg till information",
		letCandidateFillInfo: "Låt kandidaten fylla i uppgifterna själv",
		master: "Mastergrad/Hovedfag",
		masterexamen: "Masterexamen",
		navnNo: "Navn:",
		newCandidate: "Ny Kandidat",
		newCandidateModalTitle: "NewCandidateModal",
		nocandidates: "Du har inga kandidater",
		notestsforcandidate: "Denna kandidat har inte slutfört några tester",
		pasteEmails: "Klistra in e-post, en e-post per linje",
		phd: "Doktorgrad",
		question_excludeReadingTest: "Vill du utesluta deltestet läsförståelse? Detta kan göras för barn som ännu inte har lärt sig läsa.",
		regionLabel: "Region:",
		remembertoprovideemail: "Märk att e-postadresserna måste avskiljas med ett komma-tecken, exempelvis:",
		saveuserinformation: "Spara information om testkandidaten",
		sistaAretForeSkolestart: "Sista året före skolstart",
		sisteArForSkolestart: "Siste år før skolestart",
		skolaLabel: "Skola:",
		sprakAnnat: "Annat",
		sprakArabiska: "Arabiska",
		sprakEngelska: "Engelska",
		sprakJa: "Ja",
		sprakKurdiska: "Kurdiska",
		sprakNej: "Nej",
		sprakNorska: "Norska",
		sprakPolska: "Polska",
		sprakRyska: "Ryska",
		sprakSamiska: "Samiska",
		sprakSpanska: "Spanska",
		sprakTamil: "Tamil",
		sprakThai: "Thai",
		sprakTurkiska: "Turkiska",
		studieforberedandePro: "Studieförberedande program",
		testCandidateTakeTestWith: "Testkandidaten startar testet genom att",
		testCommenceInstructions1: "Väljer ”TA TESTEN” högst upp på sidan",
		testCommenceInstructions2: "Välj sedan Dysmate-C screeningtest",
		testCommenceInstructions3: "Skriv in testnyckeln",
		testCommenceInstructions4: "Logga in med pinkod",
		testCommenceInstructions5: "E-post är valfritt. Om fältet lämnas tomt behöver du dom testledare ge pinkoden till testkandidaten så denne kan logga in.",
		testCommenceInstructions6: "Om du skriver in en e-postadress så skickas både testnyckel och pinkod till testkandidatens mejl.",
		testDistributedSuccessfully: "Testerna har nu skickats iväg!",
		testInfoLagratsFormat: "Informationen om testkandidaten har lagrats. Testet är färdigt och kan starts med pinkod {0}",
		testInfoLagratsUtan: "Informationen om testkandidaten har lagrats. Testet är färdigt och kan starts med pinkod.",
		testinstallningar: "Testinställningar",
		testredistributed: "Testen er sendt til kandidaten. Ny pinkode er {0} (Hvis kandidaten skal logge inn med e-post)",
		testsenttocandidate: "Testet har nu skickats till kandidaten",
		tillgangligaSprak: "Tillgängliga språk",
		tillgangligaTester: "Tillgängliga tester",
		toSprak: "To språk",
		tvaSprak: "Två språk",
		ungdomsprogram: "Ungdomsprogram",
		uppgifterOmTestkandidaten: "Uppgifter om testkandidaten",
		userinformation: "Kandidatinformation",
		vaxtUpp: "Växt upp i ett- eller tvåspråkigt hem?",
		vetInteSprak: "Vet inte",
		yrkesprogram: "Yrkesprogram",
		allmycandidates: "Alla mina kandidater",
		age_specified: "Ålder (år)",
		antalKandidater: "Antal kandidater",
		bekräftaUtskick: "Bekräfta utskick",
	},

	// ===================================================================
	// classes
	// ===================================================================
	classes: {
		addToExistingClass: "Lägg till i befintlig klass",
		addingToGroup: "Lägg till",
		addtogroup: "Lägg till i gruppen",
		allaMinaKlasser: "Alla mina klasser",
		alreadyexistsingroup: "finns redan I gruppen!",
		cannotDeleteClassNotOwner: "Det är inte tillåtet att radera en klass som inte är skapad av dig.",
		cannotaddexistingmembertogroup: "Kan ikke legge til medlemmer som allerede er i gruppen",
		chooseagroup: "Välj en grupp",
		chooseclass: "Välj klass",
		choosegroup: "Välj grupp",
		classGrade: "Årskurs",
		classOverview: "Klassöversikt",
		classexistchoosename: "Denna klass finns redan, vänligen välj ett annat namn.",
		classindicator: "-----Klasser-----",
		classingroupalready: "Den valda klassen ligger redan i alla tillgängliga grupper.",
		confirmationdeleteclass: "Är du säker på att du vill radera detta {0}",
		createclass: "Skapa Klass",
		createnewgroup: "Opprett ny gruppe",
		deleteGroup: "Delete Group",
		deleteclass: "Radera klass",
		dessaKandidaterKommerAttLaggasTillIKlassen: "Dessa kandidater kommer att läggas till i klassen.",
		editGroup: "Edit Group",
		groupalreadyexists: "Gruppen eksisterer allerede",
		groupindicator: "-----Grupper-----",
		groupname: "Gruppnamn",
		groups: "Grupper",
		gruppenEksistererAllerede: "Gruppen finns redan",
		ingaklassertillgangliga: "Inga klasser tillgängliga",
		ingengruppvald: "Ingen grupp vald",
		inteTillagdaIKlass: " inte tillagda i klass",
		kandidaterIGrupper: "Kandidater i grupper",
		kandidaterLagtTilIGruppen: " kandidater tillagda i gruppen",
		kandidaterValda: "{0} kandidat(er) valda",
		kandidaternaFarTestUtanGruppkoppling: "Kandidaterna får test utan gruppkoppling.",
		klasserIGrupper: "Klasser i grupper",
		klassnamn: "Klassnamn",
		message_noclasses: "Du har inte skapat några klasser",
		multipleclasses: "klasser",
		myclasses: "Mina klasser",
		mygroups: "Mina grupper",
		namnPaKlassen: "Namn på klassen",
		newclass: "Ny Klass",
		newclasscreated: "Ny klass har skapats",
		newgroup: "Ny gruppe",
		noclassresults: "Den här klassen innehåller inga testresultat",
		nogroupcreateone: "Du har inga grupper. Skapa en grupp först.",
		nogroupsfound: "Inga grupper funna",
		removefromclass: "Ta bort från klassen",
		removefromgroup: "Fjern fra grupper",
		removingFromGroupInfo: "Om testet är delat i en grupp, kommer detta att ta bort testet från gruppen det lades till i.",
		selectGroup: "Välj grupp",
		selectedTestAddedToGroup: "Valda {0}  har lagts till i gruppen",
		selectedTestRemovedFromGroup: "Valda {0} har tagits bort från grupper",
		skapaKlassEllerLaggTill: "Skapa klass/eller lägg till i klass",
		skapaNyKlass: "Skapa ny klass",
		skapaNyKlassMedValdaKandidater: "Skapa en ny klass med de valda kandidaterna.",
		testCandidate: "Testkandidat",
		testcandidateadded: "Testkandidaten har lagts till I klasslistan",
		testcandidateremoved: "Testkandidaten har raderats från klasslistan",
		testetkopplastillvaldgrupp: "Testet kopplas till vald grupp.",
		theclass: "Klass",
		valdaKandidater: "valda kandidater",
		valdaKandidater_ReverseCamelCase: "Valda kandidater",
		valdaTestkandidater: "Valda testkandidater",
		valjAtgard: "Välj åtgärd",
		valjKlassDuAgerOchLaggTillKandidaternaDar: "Välj en klass du äger och lägg till kandidaterna där.",
		velgMinstEnKlasseOgEnGruppe: "Välj minst en klass och en grupp.",
		warning_deletegroup: "Er du sikker på at du vil slette denne gruppen?",
		warning_deletemember: "Er du sikker på at du vil slette dette medlemmet?",
		writeclassname: "Ge klassen ett namn…",
		writegroupname: "skriv gruppenavn...",
	},

	// ===================================================================
	// testView
	// ===================================================================
	testView: {
		addnotes: "Lägg till dina anteckningar",
		alderVidTestgenomforandet: "Ålder vid testgenomförandet",
		anvandTidSekunderAntalFel: "\nAnvänd tid: {0} sekunder\nAntal fel: {1}",
		asessmenttextnotok_1: "{0} har uppnått ett resultat under normalområdet för {1} av de {2} delproven, och bör genomgå vidare utredning för dyslexi och/eller läsförståelsesvårigheter",
		asessmenttextok_1: "{0} har uppnått ett resultat inom normalområdet eller bättre för {1} av delproven och verkar ha god läs- och skrivförmåga",
		assesmentok_recommendation_youthfollowup: "Om {0} har uppnått resultat under genomsnittsområdet på läsförståelse- och/eller ordförståelsetestet, eller eventuellt på något av de andra deltesten i Dysmate screeningtest, rekommenderar vi en vidare utredning med avseende på möjliga läsförståelsesvårigheter och/eller underliggande språkliga svårigheter såsom utvecklingsrelaterad språkstörning (DLD).",
		assesmenttextok_youthfollowup: "{0} resultat ger inga utslag på de typiskt kognitiva markörerna för dyslexi.",
		assessment: "Bedömningar baserade på resultaten:",
		assessmentBHFI: "{0} har utslag på Fonemisolasjon, og oppnår på denne testen en skåre som ligger {1} standardavviksenheter under gjennomsnittet for sitt trinn. Fonemisolasjonstesten måler fonembevissthet og fonologisk prosesseringshastighet. Svake ferdigheter på dette området er en kognitiv markør på dysleksi.",
		assessmentBHFU: "{0} har utslag på Fonemutelatelse, og oppnår på denne testen en skåre som ligger {1} standardavviksenheter under gjennomsnittet for sitt trinn. Fonemutelatelsestesten måler fonembevissthet og fonologisk prosesseringshastighet. Svake ferdigheter på dette området er en kognitiv markør på dysleksi.",
		assessmentBHRI: "{0} har utslag på Hurtigbenevning, og oppnår en skåre som ligger {1} standardavviksenheter under gjennomsnittet for sitt trinn på denne testen. Hurtigbenevningstesten måler hvor raskt og nøyaktig man greier å hente frem ord fra språkminnet. Svake ferdigheter på dette området er en kognitiv markør på dysleksi",
		assessmentBHWM: "{0} har utslag på Arbeidsminne, og oppnår en skåre som ligger {1} standardavviksenheter under gjennomsnittet for sitt trinn på denne testen. Arbeidsminne er i seg selv ikke en kognitiv markør på dysleksi, men er assosiert med både dysleksi og leseforståelsessvikt. Redusert arbeidsminne kan blant annet påvirke hvor mye informasjon man greier å få med seg fra lest tekst. Det anbefales derfor å undersøke i hvor stor grad arbeidsminnet til {2} påvirker tilegnelsen av nytt fagstoff, og om det er behov for skolefaglig tilrettelegging rundt dette.",
		assessmentBHonlyLK: "{0} har lavere enn forventet bokstavkunnskap for trinnet. Dette kan ha sammenheng med fremgangsmåten for bokstavinnlæringen på skolen. Det anbefales likevel at man følger nøye med utviklingen i elevens bokstav-lyd-innlæring.",
		assessmentokBHtest: "{0} har oppnådd resultater som ligger i gjennomsnittsområdet eller bedre for testene, og ser ut til å ligge på det nivå som er typisk for sin alder på områder som er viktig for å utvikle gode lese- og skriveferdigheter.",
		assessmentspeechnotok: "{0} har uppnått ett resultat under normalområdet för det experimentella enminutstestet och bör genomgå vidare utredning för dyslexi och/eller läsförståelsesvårigheter",
		assessmentspeechok: "{0} har uppnått ett resultat inom normalområdet eller bättre för det experimentella enminutstestet och verkar ha goda läsförmågor.",
		assessmentsubtestbelow: "Detta resultat ligger {0} standardavvikelser {1} genomsnittet",
		assessmentsubtestnormal: "Detta resultat ligger inom normalområdet",
		averageForGrade: "medelvärdet för årskursen.",
		averagezscore: "Genomsnittligt Z-värde",
		bedomningsSaknas: "Bedömning saknas",
		bekreftelseOmDysleksi: "Bekreftelse på dysleksi",
		betydligtUnder: "betydligt under på {0} av deltesterna",
		betydligtUnderMedRange: "betydligt under (-2.01 -> -3.0) på {0} av deltesterna",
		candidate_answers: "Svar från kandidaten",
		candidatetext: "Kandidatens text",
		cantretrieveaudio: "Vi kunne ikke finne lydfiler for denne testen",
		childscrng_norms_intro: "Jämförelsevärden (så kallade normer) har samlats in för varje årskurs i en representativ grupp av elever över hela landet. Här beaktades förutom årskurs även kön (pojkar/flickor). För ytterligare information om normeringen av Dysmate-C, se handboken.",
		childscrng_text1: "{0} har uppnått ett resultat som ligger {1}.\n\n{2}\n\nEftersom {3} erhöll svaga resultat på {4} rekommenderas att testkandidaten genomför Dysmate-uppföljningstest. För ytterligare fördjupning i resultaten rekommenderas att man läser {5}.",
		childscrng_text2: "{0} har uppnått resultat som ligger {1}. {2}\n\nEftersom {3} erhöll svaga resultat på {4} rekommenderas att testkandidaten genomför Dysmate-uppföljningstest. Om {6} även erhåller svaga resultat gällande Arbetsminne och Snabb automatiserad benämning/RAN i uppföljningstestet rekommenderas en utökad bedömning av testkandidatens språkförståelse. För ytterligare fördjupning i resultaten rekommenderas att man läser {5}.",
		childscrng_text3: "{0} har uppnått ett resultat som ligger {1}.\n\n{2}\n\nResultatet på Fonembyte-testet indikerar att det bör göras en närmare bedömning av {3} fonemiska medvetenhet och fonologiska bearbetningshastighet. Det rekommenderas därför att Dysmate-C uppföljningstestet genomförs. För ytterligare fördjupning i resultaten rekommenderas att man läser {4}, Kapitel 6:\nRiktlinjer för tolkning.",
		childscrng_text4: "{0} uppnår resultat som ligger inom och/eller klart över genomsnittsområdet på {1} av deltesterna. Resultaten från screeningtestet ger inte någon indikation på behov av uppföljningstest med Dysmate.",
		childscrng_text5: "{0} har inte slutfört hela screeningtestet, och det finns därför ingen grund för att ge några rekommendationer om ytterligare uppföljning.",
		comments: "Kommentarer",
		correctAnswerConfirmation: "Vennligst bekreft hvorvidt ordet var lest riktig eller feil",
		correctanswer: "Korrekt svar",
		datumForTestgenomforandet: "Datum för testgenomförandet",
		deltest: "Deltest",
		dysmateSager: "Dysmate säger:",
		dynamicheaderfortestcandidate_adult: "Detaljerad information för Dysmatekandidat {0}",
		dynamicheaderfortestcandidate_child: "Detaljerad information för Dysmatekandidat {0}",
		dynamicheaderfortestreport_adult: "Detaljerad rapport för Dysmate {0}",
		dynamicheaderfortestreport_child: "Detaljerad rapport för Dysmate {0}",
		dynamicheaderfortestresult_adult: "Detaljerade resultat för Dysmate {0}",
		dynamicheaderfortestresult_child: "Detaljerade resultat för Dysmate {0}",
		fonemsubtraktionlowassesment: "Resultatet ger utslag på deltestet Fonemsubtraktion (Ta bort ljud) och {0} resultat ligger {1} standardavvikelser under genomsnittet för sin årskurs. Deltestet mäter fonemisk medvetenhet och fonologisk bearbetningshastighet. En svaghet inom detta område är en kognitiv markör för dyslexi.",
		genomsnittsomrade: "Genomsnittsområde",
		greenAverageArea: "Grön: Z-poäng över genomsnittsområdet",
		handbokDysmate: "Håndbok Dysmate",
		handbooktitle: "{0} På denna sida hittar du användbara resurser för att använda Dysmate.",
		hideunanswered: "Dölj obesvarade",
		incompleteMessage: "Testet är inte genomfört. Delprov saknas eller har ej påbörjats.",
		infor_scr_ageAtCommencement: " Ålder vid testgenomförandet var {0} år och {1} månader.",
		info_report_belowpresentsinformation: "Nedanför presenteras testrapport för {0}{1}{2}",
		info_results_belowpresentsinformation: "Nedanför presenteras testresultaten för {0}{1}{2}",
		info_testwasNotcompletedon: " Detta test är ej slutfört.",
		info_testwascompletedon: "Testet slutfördes den {0}",
		info_user_belowpresentsinformation: "Nedenfor presenteres kandidatopplysninger for {0}{1}{2}",
		inom: "inom",
		inomNormalomradet: "Inom normalområdet",
		inomOchKlartOver: "inom och klart över",
		klartOchBetydligtUnder: "klart under på {0} av deltesterna och betydligt under på {1} av deltesten ",
		klartOver: "klart över",
		klartUnder: "klart under på {0} av deltesterna",
		klartUnderMedRange: "klart under (-1.01-> -2.0) på {0} av deltesterna",
		kommentarenSkrivenAv: "Kommentaren är skriven av testadministratör:",
		kommentarer: "Kommentarer",
		lagretAv: "Lagret av",
		localizedwriteuptextforIncompletedTest: "{0} har inte genomfört hela screeningtestet och det saknas därmed underlag för att ge några rekommendationer om ytterligare uppföljning. ",
		localizedwriteuptextforLowScoreInLeseprovenAndOrdforstaelse: "{0} har uppnått ett resultat som ligger {1} {2} {3}. {4} Eftersom {5} uppnår svaga resultat på ordförståelse- och läsförståelsetestet rekommenderas att testkandidaten genomför Dysmate uppföljningstest. ",
		localizedwriteuptextforLowScoreOfOrdiktatWithOneOtherSubTest: "Stavningssvårigheter kan vara en indikation på dyslexi. {0} resultat på stavningstestet indikerar att ett Dysmate uppföljningstest bör genomföras.",
		localizedwriteuptextforNormalresults: "{0} uppnår resultat som ligger  {1} {2} {3} genomsnittet vid {4} av deltesterna. Detta indikerar att {5} har goda läs- och skrivfärdigheter.",
		localizedwriteuptextforOneOtherSubTest: "{0} har uppnått ett resultat som ligger {1} {2} {3}. {4} {5}",
		localizedwriteuptextforThreeORMoreOtherSubTest: "{0} har uppnått ett resultat som ligger {1} {2} {3}. {4} Eftersom {5} uppnår svaga resultat på {6}, {7}, {8} {9} {10} {11} rekommenderas att kandidaten genomför Dysmate uppföljningstest.",
		localizedwriteuptextforTwoOtherSubTest: "{0} har uppnått ett resultat som ligger {1} {2} {3}. {4} Eftersom {5} uppnår svaga resultat på {6}, {7} och {8} rekommenderas att kandidaten genomför Dysmate uppföljningstest.",
		newinfo2_belowpresentsinformation: "Nedanför presenteras testrapport för {0} Född: {1} {2}",
		newinfo3_belowpresentsinformation: "Nedanför presenteras kandidatinformation för {0} Född {1} {2} {3}",
		newinfo_belowpresentsinformation: "Nedanför presenteras testresultaten för {0} Född: {1} {2}",
		notanswered: "ej besvarad",
		notetsfound: "Inga slutförda test hittades",
		nyRapportlayout: "Ny rapportlayout – förhandsvisning. Denna är ännu inte kopplad till utskrift.",
		ochBetydligtUnderMedRange: " och betydligt under (-2.01 -> -3.0) på {0} av deltesterna",
		oneminutelowassesment: "Resultatet ger utslag vid 1-minuts ordavkodning och {0} erhåller ett resultat som ligger {1} standardavvikelser under genomsnittet för sin årskurs eller ålder vid detta test. 1-minuts ordavkodning ger ett rent mått på antalet korrekt lästa ord per minut och ger en bra bild av avkodningsförmågan. Svag avkodningsförmåga är en markör för dyslexi.",
		oneminutelowassesment2: "OBS! Vi rekommenderar att resultatet vid 1-minuts ordavkodning tas i beaktande tillsammans med resultaten från Stavnings- och Ordkedjetestet i Dysmate screeningtest.",
		oppgaverIkkeBesvart: "uppgifter inte besvarade",
		oppsumering: "Oppsumering",
		overGenomsnittsomradet: "Över genomsnittsområdet",
		overview: "Överblick",
		printInformation: "Skriv ut kandidatinformation",
		printreport: "Skriv ut testrapport",
		printtestresults: "Skriv ut resultat",
		rapidnominationlowassesment: "Resultatet ger utslag vid snabb automatiserad benämning, och {0} erhåller ett resultat som ligger {1} standardavvikelser under genomsnittet för sin årskurs eller ålder vid detta test. Snabb automatiserad benämning mäter hur snabbt och exakt man kan hämta fram ord från språkminnet. Svaga färdigheter inom detta område är en kognitiv markör för dyslexi.",
		rapport: "Rapport",
		rapportDysmate: "Rapport Dysmate",
		rattAv50MojligaPa: "{0} rätt av 50 möjliga på {1} sekunder",
		rattAvMojliga: "{0} rätt av {1} möjliga",
		redAverageArea: "Röd: Z-poäng under genomsnittsområdet",
		reminderScoreChange: "Før du endrer statusen til dette bestemte svaret, vil vi minne deg om at dette vil påvirke kandidatens poengsum",
		resterandeDeltesterna: "På de resterande deltesterna ligger {0} inom eller klart över genomsnittsområdet.",
		resterandeDeltesternaUppnar: "På de resterande deltesterna uppnår {0} resultat som ligger inom eller klart över genomsnittet.",
		resultsReport: "Resultatrapport",
		resurshafteDysmate: "Resurshäfte Dysmate",
		retteAv40MuligePa: "{0} rette av 40 mulige på {1} sekunder",
		rightanswer: "Korrekt besvarade: {0}",
		screeningensDeltest: "Screeningens deltest",
		showunanswered: "Visa obesvarade",
		skrivInDinaAnteckningar: "Skriv in dina anteckningar här...",
		skrivUtMedAnteckningar: "Skriv ut med anteckningar",
		spoonerismlowassesment: "Resultatet ger utslag vid Spoonerismer, och {0} erhåller ett resultat som ligger {1} standardavvikelser under genomsnittet för sin årskurs eller ålder på detta test. Spoonerism-testet mäter fonemmedvetenhet och fonologisk bearbetningshastighet. Svaga färdigheter inom dessa områden är en kognitiv markör för dyslexi.",
		summary: "Sammanfattning",
		summery: "Sammanfattning",
		tScoreLabel: "T-score",
		testnotanswered: "{0} frågor ej besvarade",
		testreport: "Skriv ut testrapport",
		testresult: "Skriv ut testresultat",
		textUnderEveryChildFollowupAssessment: "I Dysmate används regressionsbaserade normer för att bedöma resultaten. Det innebär att faktorer som kön och årskurs tas i beaktande för att sätta det individuella testresultatet (beräknat från råpoängen i respektive deltest) i relation till en jämförelsegrupp.",
		textUnderEveryFollowupAssessment: "I Dysmate används regressionsbaserade normer för att beräkna testkandidatens resultat. Detta innebär att faktorn årskurs beaktas för att beräkna ett förväntat medelvärde för den grupp som testkandidaten tillhör. I deltesterna Arbetsminne och Spoonerismer ingår även kön som en faktor för att beräkna kandidatens resultat. Testkandidatens råpoäng jämförs med medelvärdet för att beräkna avståndet mellan dessa. Avståndet till medelvärdet beräknas genom att subtrahera medelvärdet från kandidatens råpoäng. Avståndet divideras sedan med standardavvikelsen för gruppen, vilket resulterar i en Z-poäng. Z-poängen visar testkandidatens resultat i förhållande till normgruppen, där medelvärdet är 0 och standardavvikelsen är 1.",
		textUnderEveryScreeningAssessment: "I Dysmate används regressionsbaserade normer för att beräkna testkandidatens resultat. Detta innebär att faktorn årskurs beaktas för att beräkna ett förväntat medelvärde för den grupp som testkandidaten tillhör. Testkandidatens råpoäng jämförs med medelvärdet för att beräkna avståndet. Avståndet till medelvärdet beräknas genom att subtrahera medelvärdet från kandidatens råpoäng. Avståndet divideras sedan med standardavvikelsen för gruppen, vilket resulterar i en Z-poäng. Z-poängen visar testkandidatens resultat i förhållande till normgruppen, där medelvärdet är 0 och standardavvikelsen är 1.",
		theAverage: "gjennomsnittet.",
		underGenomsnittsomradet: "Under genomsnittsområdet",
		uppfoljningensDeltest: "Uppföljningens deltest",
		villLaggaTillAnteckningar: "Vill du lägga till anteckningar innan utskrift?",
		wordreadcorrectly: "Korrekt lästa ord",
		workingmemorylowassesment: "Resultatet ger utslag på Arbetsminne, och {0} erhåller ett resultat som ligger {1} standardavvikelser under genomsnittet för sin årskurs eller ålder på detta test. Arbetsminne är i sig inte en kognitiv markör för dyslexi, men är förknippat med både dyslexi och läsförståelsesvårigheter. Nedsatt arbetsminne kan bland annat påverka hur mycket information man lyckas behålla från en läst text. Det rekommenderas därför att undersöka i vilken utsträckning arbetsminnet påverkar testkandidatens generella inlärningsförmåga och om det finns behov av skolbaserade insatser och anpassningar i detta avseende.",
		yellowAverageArea: "Gul: Z-poäng inom genomsnittsområdet",
		zScoreLabel: "Z-score",
		zSkare: "Z-skåre",
		zSkareLabel: "Z-skåre",
		zscoreblue: "Z-poäng ligger inom genomsnittsområdet",
		zscoregreen: "Z-poäng mer än 1 standardavvikelse {0} genomsnittet",
		zscorered: "Z-poäng mer än 1 standardavvikelse {0} genomsnittet",
		oppfølgingstiltak: "Oppfølgingstiltak",
	},

	// ===================================================================
	// subtests
	// ===================================================================
	subtests: {
		arbeidminneheading: "Detta test identifierar testkandidatens förmåga att lagra och bearbeta information. I detta test presenteras för testkandidaten en serie siffror, sedan en serie ord, vilka ska upprepas i motsatt ordning. Både sifferraderna och ordraderna ökar I längd om testkandidaten klarar den föregående raden.",
		arbeidsminneexplanation: "För varje rätt svar ges en poäng (max 12 poäng för sifferserien och max 12 poäng för ordserien, totalt max 24 poäng). Förväntat testresultat, baserat på testkandidatens årskurs, är {0} och standardavvikelsen är {1}. ",
		arbeidsminneheading: "Detta test identifierar testkandidatens förmåga att lagra och bearbeta information. I detta test presenteras för testkandidaten en serie siffror, sedan en serie ord, vilka ska upprepas i motsatt ordning. Både sifferraderna och ordraderna ökar I längd om testkandidaten klarar den föregående raden.",
		arbeidsminnenummberheading: "Detta test mäter kandidatens förmåga att lagra och bearbeta information samtidigt som man löser en uppgift. Testkandidaten presenteras först för en serie med siffror och sedan en serie med ord. Dessa ska sedan upprepas i omvänd ordning från hur de presenterades. Både sifferserien och ordserien ökar i längd.",
		arbeidsminnevariabletext: "{0} uppnår en poäng om {1} på detta deltest. Detta resultat ligger {2} standardavvikelser från medelvärdet för årskursen. {3} uppnår därmed ett resultat som ligger ",
		arbetsminne_childfollowup_explanation: "För varje rätt svar erhålls en poäng (maximalt 12 poäng för sifferserien och 12 poäng för ordserien, totalt 24 poäng). Förväntat resultat för kandidaten är {0}.",
		arbetsminne_childfollowup_heading: "Detta deltest mäter testkandidatens förmåga att kortvarigt lagra, bearbeta och återge verbal information. Testkandidaten får först höra serier med siffror och sedan med ord, vilka testkandidaten ska upprepa i omvänd ordning. Både sifferserien och ordserien ökar i längd om kandidaten klarar den föregående serien. Deltestet avbryts automatiskt efter två felaktiga svar eller icke-svar i följd.",
		arbetsminne_childfollowup_variabletext: "{0} uppnådde i detta deltest en råpoängssumma om {1}. {3} uppnår alltså ett resultat som ligger ",
		bokstavkunnskapexplanation: "Det gis ett poeng for hvert riktig svar (maks 15 poeng for lyd og maks 15 poeng for navn, til sammen maks 30 poeng). Gjennomsnittsskåren for {0} er {1} og standardavviket er {2}.",
		bokstavkunnskapheading: "Denne testen kartlegger bokstavkunnskap hos de yngste elevene. På denne testen presenteres 15 av bokstavene i det norske alfabetet i tilfeldig rekkefølge. Kandidaten blir så bedt om å si både navnet og lyden til bokstavene. ",
		bokstavkunnskapvariabletext: "{0} oppnådde på denne testen en skåre på {1}. Denne skåren plasserer seg {2} standardavviksenheter fra gjennomsnittet for trinnet. {3} oppnår dermed et resultat som plasserer seg",
		bokstavkunnskapvariabletextBH: "{0} oppnådde på denne testen en skåre på {1}. Gjennomsnitt og standardavvik for dette trinnet er ikke tilgjengelig.",
		bytaljud_childscrng_explanation: "För varje korrekt svar ges en poäng, och högst 21 poäng kan uppnås. Förväntat resultat för kandidaten är {0}.\n\nReferensvärden (så kallade normer) har tagits fram för varje årskurs i en representativ elevgrupp på nationell nivå. I detta sammanhang har hänsyn tagits till både årskurs och kön (pojkar/flickor). För ytterligare information om normeringen av Dysmate-C, se handboken.",
		bytaljud_childscrng_heading: "Detta test mäter fonologisk medvetenhet och fonologisk bearbetningshastighet, vilka är språkliga och kognitiva markörer för dyslexi. Uppgiften består i att testkandidaten ska byta ut ett visst enskilt ljud i ett ord mot ett annat och därmed bilda ett nytt ord. Ett exempel är att byta ut ljudet /b/ i ordet «bil» med ljudet /p/. I varje uppgift visas en illustration av målordet (t.ex. bil) följt av fyra illustrerade svarsalternativ. Endast ett av alternativen är korrekt (här: «pil»), de övriga illustrationerna fungerar som distraktorer. Testkandidaten har 10 sekunder på sig att lösa varje uppgift. En ny uppgift startar automatiskt på skärmen om kandidaten inte har svarat inom tidsgränsen. Vid fem på varandra följande felaktiga svar avslutas testet.",
		bytaljud_childscrng_variabletext: "{0} har i detta deltest uppnått en råpoängsumma om {1}, vilket motsvarar en prestation som ligger",
		ettminuttstestexplanation: "En poäng ges för varje korrekt läst ord. Förväntat testresultat, baserat på testkandidatens årskurs, är {0} och standardavvikelsen är {1}.",
		ettminuttstestheading: "Detta är ett högläsningstest som bedömer ordavkodningsförmåga. Kandidaten får en lista med ord och ombeds att läsa så snabbt och korrekt som möjligt inom en tidsram på 60 sekunder. Resultatet ger ett mått på antalet korrekt lästa ord per minut.",
		ettminuttstestvariabletext: "{0} uppnår en poäng om {1} på detta deltest. Detta resultat ligger {2} standardavvikelser från medelvärdet för årskursen. {3} uppnår därmed ett resultat som ligger ",
		fonemisolasjonexplanation: "Ett poäng tilldelas för varje korrekt svar (maximalt 16 poäng). Genomsnittspoängen för {0} är {1} och standardavvikelsen är {2}.",
		fonemisolasjonheading: "Detta test identifierar fonemmedvetenhet hos de yngsta testkandidaterna. I detta test visas fyra bilder för testkandidaten och hen ombeds peka på den bild som antingen börjar eller slutar med ett visst ljud.",
		fonemisolasjonvariabletext: "{0} uppnådde en poäng på {1} på detta test. Denna poäng placeras {2} standardavvikelser från detta stegs medelvärde. Detta resultat placeras",
		fonemsubtraktion_childfollowup_explanation: "För varje korrekt svar erhålls en poäng. Förväntat resultat för kandidaten är {0}.",
		fonemsubtraktion_childfollowup_heading: "Detta test mäter fonemisk medvetenhet och hur väl testkandidaten kan uppmärksamma och arbeta med språkljud. \n\tTestkandidaten får höra ett ord och ska säga vad som blir kvar när man tar bort ett bestämt ljud i ordet (t.ex. /g/ i «gris» → «ris»).\n\nFör varje rätt svar erhålls en poäng (maximalt 16 poäng).",
		fonemsubtraktion_childfollowup_variabletext: "{0} uppnådde i detta deltest en råpoängssumma om {1}. {3} uppnår alltså ett resultat som ligger ",
		hurtigbenevningBHexplanation: "Det gis ett poeng for hver riktig kombinasjon av farge og objekt kandidaten sier. Denne testen går også på tid. Skåren her er antall riktige farge-objekt-kombinasjoner dividert med den totale tiden det tar å benevne alle 25 farge-objekt-kombinasjonene. Gjennomsnittsskåren for {0} er {1} og standardavviket er {2}.",
		hurtigbenevningexplanation: "En poäng ges för varje korrekt kombination av färg och föremål som kandidaten namnger. Testet är också tidsbestämt. Poängen beräknas utifrån antalet korrekta färg- och föremålskombinationer dividerat med den totala tiden det tar att nämna alla 50 färg- och föremålskombinationer. Förväntat testresultat, baserat på testkandidatens årskurs, är {0} och standardavvikelsen är {1}. ",
		hurtigbenevningheading: "Detta test bedömer hur snabbt kandidaten kan namnge bekanta föremål och hämta fram namn på föremål och färger från det språkliga långtidsminnet.",
		hurtigbenevningvariabletext: "{0} uppnår en poäng om {1} på detta deltest. Detta resultat ligger {2} standardavvikelser från medelvärdet för årskursen. {3} uppnår därmed ett resultat som ligger ",
		lasforstaelse_childscrng_explanation: "För varje korrekt svar ges en poäng, och högst 8 poäng kan uppnås. Förväntat resultat för kandidaten är {0}.\n\nReferensvärden (så kallade normer) har tagits fram för varje årskurs i en representativ elevgrupp på nationell nivå. I detta sammanhang har hänsyn tagits till både årskurs och kön (pojkar/flickor). För ytterligare information om normeringen av Dysmate-C, se handboken.",
		lasforstaelse_childscrng_heading: "Detta deltest är en tyst läsuppgift som mäter läsförståelse genom att testkandidaten ska besvara frågor utifrån texten, vilket kräver att kandidaten kan sammanfatta information från olika avsnitt och dra slutsatser utifrån en text. Testkandidaten får 10 minuter på sig att läsa texten och svara på så många flervalsfrågor som möjligt. OBS! Här är det viktigt att skilja på och notera om testkandidaten har svarat fel på flervalsfrågorna eller inte hunnit besvara frågorna (på grund av en lägre läshastighet).",
		lasforstaelse_childscrng_variabletext: "{0} har i detta deltest uppnått en råpoängsumma om {1}, vilket motsvarar en prestation som ligger",
		oneminute_childfollowup_explanation: "En poäng ges för varje korrekt läst ord. Förväntat resultat för kandidaten är {0}. Resultatet tolkas i relation till referensvärden för testkandidatens årskurs.",
		oneminute_childfollowup_heading: "Detta är ett högläsningstest som bedömer avkodningsförmåga på ordnivå. Testkandidaten får en lista med ord och ombeds att läsa så snabbt och korrekt som möjligt inom en tidsram på 60 sekunder. Resultatet ger ett mått på antalet korrekt lästa ord per minut.",
		oneminute_childfollowup_variabletext: "{0} uppnådde i detta deltest en råpoängssumma om {1}. {3} uppnår alltså ett resultat som ligger ",
		oneminutetestExperimental: "1-min test (talegjenkjenning)",
		orddiktatadultexplanation: "Ett poäng tilldelas för varje korrekt svar (maximalt 45 poäng). Genomsnittspoängen för {0} är {1} och standardavvikelsen är {2} .",
		orddiktatchildexplanation: "För varje korrekt svar ges en poäng, och högst 25 poäng kan uppnås.\n\tReferensvärden (så kallade normer) har tagits fram för varje årskurs i en\nrepresentativ elevgrupp på nationell nivå. I detta sammanhang har hänsyn tagits\ntill både årskurs och kön (pojkar/flickor). För ytterligare information om\nnormeringen av Dysmate-C, se handboken.\n\t",
		orddiktatchildheading: "Detta deltest mäter stavningsförmåga samt ortografisk medvetenhet. Testkandidaten ska skriva ord som läses upp högt. Varje ord presenteras först i en mening för att säkerställa att den korrekta innebörden av ordet som ska stavas uppfattas, varefter målordet upprepas. Deltestet har ingen tidsbegränsning. Både meningen och målordet kan vid behov upprepas en gång.",
		orddiktatheading: "Varje ord presenteras först i en mening för att säkerställa att den korrekta innebörden av ordet som ska stavas förstås. Därefter ombeds kandidaten att skriva målordet som då upprepas. Det finns ingen tidsgräns på detta deltest och både mening och målord kan upprepas en gång.",
		orddiktatvariabletext: "{0} uppnådde en poäng om {1} på detta deltest. Detta resultat ligger {2} standardavvikelser från medelvärdet för årskursen. {3} uppnår därmed ett resultat som ligger",
		orddiktatyouthexplanation: "En poäng ges för varje korrekt stavat ord (max 40 poäng). Förväntat testresultat, baserat på testkandidatens årskurs, är {0} och standardavvikelsen är {1}.",
		ordforstaelse_childscrng_explanation: "För varje korrekt svar ges en poäng, och högst 18 poäng kan uppnås. Förväntat resultat för kandidaten är {0}.\n\nReferensvärden (så kallade normer) har tagits fram för varje årskurs i en representativ elevgrupp på nationell nivå. I detta sammanhang har hänsyn tagits till både årskurs och kön (pojkar/flickor). För ytterligare information om normeringen av Dysmate-C, se handboken.",
		ordforstaelse_childscrng_heading: "Detta deltest mäter receptivt ordförråd och semantisk kunskap. Testkandidaten ombeds hitta ett ord från en utvalslista som har samma betydelse som ett givet målord. I varje uppgift får testkandidaten välja mellan fyra alternativ.",
		ordforstaelse_childscrng_variabletext: "{0} har i detta deltest uppnått en råpoängsumma om {1}, vilket motsvarar en prestation som ligger",
		ordkedjor_childscrng_explanation: "För varje korrekt svar (korrekt uppdelat ord) ges en poäng. Förväntat resultat för kandidaten är {0}.\n\nReferensvärden (så kallade normer) har tagits fram för varje årskurs i en representativ elevgrupp på nationell nivå. I detta sammanhang har hänsyn tagits till både årskurs och kön (pojkar/flickor). För ytterligare information om normeringen av Dysmate-C, se handboken.",
		ordkedjor_childscrng_heading: "Detta deltest syftar till att mäta tyst läsförmåga och hastigheten i ordigenkänning och ortografisk kunskap. Här ombeds testkandidaten att skapa ett mellanrum mellan ord som är ihopskriva i en kedja. Varje kedja består av fyra slumpmässiga ord. Testkandidaten får 4 minuter på sig att lösa så många ordkedjor som möjligt.",
		ordkedjor_childscrng_variabletext: "{0} har i detta deltest uppnått en råpoängsumma om {1}, vilket motsvarar en prestation som ligger",
		ordkjedetestenexplanation: "Ett poäng tilldelas för varje korrekt svar (maximalt 40 poäng). Genomsnittspoängen för {0} är {1} och standardavvikelsen är {2}.",
		ordkjedetestenheading: "Detta är ett tyst lästest som mäter snabb ordigenkänning och ortografisk kunskap. Här ombeds testkandidaten att skapa ett mellanrum mellan ord som är ihopskriva i en kedja. Varje kedja består av fyra slumpmässiga ord. Testkandidaten får 4 minuter på sig att lösa så många ordkedjor som möjligt.",
		ordkjedetestenvariabletext: "{0} uppnådde en poäng om {1} på detta deltest. Detta resultat ligger {2} standardavvikelser från medelvärdet för årskursen. {3} uppnår därmed ett resultat som ligger ",
		ordkjedetestenyouthexplanation: "En poäng ges för varje korrekt svar (max 50 poäng). Förväntat testresultat, baserat på testkandidatens årskurs, är {0} och standardavvikelsen är {1}.",
		ran_childfollowup_explanation: "En poäng ges för varje korrekt kombination av färg och föremål som testkandidaten namnger. Förväntat resultat för kandidaten är {0}.",
		ran_childfollowup_heading: "Detta deltest mäter hur snabbt testkandidaten kan hämta fram namn på bekanta föremål och färger från det språkliga minnet. Testkandidaten uppmanas att snabbt och korrekt namnge föremål i olika färger. Poängen beräknas utifrån antalet korrekta färg- och föremålskombinationer dividerat med den totala tid det tar att namnge alla 50 färg- och föremålskombinationerna. Även detta test är tidsbestämt.",
		ran_childfollowup_variabletext: "{0} uppnådde i detta deltest en råpoängssumma om {1}. {3} uppnår alltså ett resultat som ligger ",
		skrivehastighetexplanation: "Poängen baseras på antalet korrekt skrivna ord i genomsnitt per minut. Förväntat testresultat, baserat på testkandidatens årskurs, är {0} och standardavvikelsen är {1}.",
		skrivehastighetheading: "Detta test mäter skrivflyt, alltså hur effektivt en person kan skriva. Detta är en förmåga som är viktig, exempelvis när man antecknar eller skriver ett prov. Kandidaten ser hela tiden en mening framför sig och ska skriva av den så många gånger och så korrekt som möjligt inom 2 minuter.",
		skrivehastighetvariabletext: "{0} uppnådde en poäng om {1} på detta deltest. Detta resultat ligger {2} standardavvikelser från medelvärdet för årskursen. {3} uppnår därmed ett resultat som ligger ",
		skrivflyt_childscrng_explanation: "Poängen baseras på antalet korrekt skrivna ord per minut. Förväntat resultat för kandidaten är {0}.\n\nReferensvärden (så kallade normer) har tagits fram för varje årskurs i en representativ elevgrupp på nationell nivå. I detta sammanhang har hänsyn tagits till både årskurs och kön (pojkar/flickor). För ytterligare information om normeringen av Dysmate-C, se handboken.",
		skrivflyt_childscrng_heading: "Detta deltest mäter skrivhastighet och skrivflyt, alltså effektiviteten i skrivförmågan på meningsnivå. Detta är en förmåga som är viktig, exempelvis när man antecknar eller skriver ett prov. Testkandidaten ser hela tiden en mening framför sig på sin skärm och ska skriva av den så många gånger och så korrekt som möjligt inom 2 minuter.",
		skrivflyt_childscrng_variabletext: "{0} har i detta deltest uppnått {1} ord per minut, vilket motsvarar en prestation som ligger",
		spoonerismexplanation: "En poäng ges för varje korrekt ord som kandidaten lyckas säga med det nya första ljudet (max 50 poäng). Testet är också tidsbestämt. Poängen beräknas utifrån antalet korrekta ord som har ändrat sitt första ljud, dividerat med den tid det tar att slutföra uppgifterna. Förväntat testresultat, baserat på testkandidatens årskurs, är {0} och standardavvikelsen är {1}.  ",
		spoonerismheading: "Detta test mäter fonemmedvetenhet och fonologisk bearbetningshastighet. Testkandidaten får 25 ordpar presenterade för sig muntligt och ombeds sedan att byta plats på de första ljuden i de två orden så snabbt och korrekt som möjligt.",
		spoonerismvariabletext: "{0} uppnår en poäng om {1} på detta deltest. Detta resultat ligger {2} standardavvikelser från medelvärdet för årskursen. {3} uppnår därmed ett resultat som ligger ",
		stavning_childscrng_explanation: "För varje korrekt svar ges en poäng, och högst 25 poäng kan uppnås. Förväntat resultat för kandidaten är {0}.\n\nReferensvärden (så kallade normer) har tagits fram för varje årskurs i en representativ elevgrupp på nationell nivå. I detta sammanhang har hänsyn tagits till både årskurs och kön (pojkar/flickor). För ytterligare information om normeringen av Dysmate-C, se handboken.",
		stavning_childscrng_variabletext: "{0} har i detta deltest uppnått en råpoängsumma om {1}, vilket motsvarar en prestation som ligger",
		tulleordtestenexplanation: "För varje rätt svar erhålls en poäng (max 30 poäng). Förväntat testresultat, baserat på testkandidatens årskurs, är {0} och standardavvikelsen är {1}.",
		tulleordtestenheading: "Detta test är ett tyst lästest som mäter fonologisk medvetenhet och fonologisk bearbetningshastighet. Detta anses vara en språkligt-kognitiv markör för dyslexi. Testkandidaten måste hitta det nonsensord som låter som ett riktigt ord. Vid varje uppgift måste testkandidaten välja mellan fem alternativ, varav endast ett är korrekt. Testkandidaten har två minuter på sig att lösa så många uppgifter som möjligt.",
		tulleordtestenvariabletext: "{0} uppnådde en poäng om {1} på detta deltest. Detta resultat ligger {2} standardavvikelser från medelvärdet för årskursen. {3} uppnår därmed ett resultat som ligger ",
		ordforståelseheading: "Testet mäter ordförståelse genom att testkandidaten ombeds hitta ett ord som har samma betydelse som ett givet målord. I varje uppgift får testkandidaten välja mellan fyra alternativ. Detta test ger ett mått på ordförrådets bredd och djup.",
		ordforståelseexplanation: "Ett poäng tillskrivs för varje korrekt svar (maximalt 15 poäng). Genomsnittspoängen för {0} är {1} och standardavvikelsen är {2}.",
		ordforståelsevariabletext: "{0} uppnådde en poäng om {1} på detta deltest. Detta resultat ligger {2} standardavvikelser från medelvärdet för årskursen. {3} uppnår därmed ett resultat som ligger ",
		ordforståelseyouthexplanation: "För varje rätt svar erhålls en poäng (max 20 poäng). Förväntat testresultat, baserat på testkandidatens årskurs, är {0} och standardavvikelsen är {1}.",
		leseprøvenheading: "Detta test är ett tyst läsprov som mäter läsförståelse genom att testkandidaten måste svara på frågor direkt från texten, sammanställa information från olika avsnitt och dra slutsatser. Testkandidaten har 10 minuter på sig att läsa texten och svara på så många flervalsfrågor som möjligt. N.B. Här är det viktigt att registrera om testkandidaten har svarat fel eller lämnat flervalsfrågorna obesvarade (på grund av lågläshastighet).",
		leseprøvenyouthheading: "Detta test är ett tyst lästest som mäter läsförståelse genom att testkandidaten får svara på frågor, sammanfatta information från olika avsnitt och dra slutsatser utifrån en text. Testkandidaten får 12 minuter på sig att läsa texten och svara på så många flervalsfrågor som möjligt. OBS! Här är det viktigt att läraren noterar, vid sidan av, om testkandidaten beskriver att den har svarat fel på frågorna eller inte besvarat dem (på grund av en lägre läshastighet som gjort att kandidaten inte hunnit besvara frågorna).",
		leseprøvenexplanation: "Ett poäng tilldelas för varje korrekt svar (maximalt 14 poäng). Genomsnittspoängen för {0} är {1} och standardavvikelsen är {2}",
		leseprøvenyouthexplanation: "För varje rätt svar erhålls en poäng (max 14 poäng). Förväntat testresultat, baserat på testkandidatens årskurs, är {0} och standardavvikelsen är {1}.",
		leseprøvenvariabletext: "{0} uppnådde en poäng om {1} på detta deltest. Detta resultat ligger {2} standardavvikelser från medelvärdet för årskursen. {3} uppnår därmed ett resultat som ligger ",
	},

	// ===================================================================
	// users
	// ===================================================================
	users: {
		loggedIn: "Innlogget",
		downloadandsendcontract: "För att utfärda fler test måste du ha en prenumeration. Gå till dysmate.se > priser för att teckna abonnemang, eller ladda ner kontraktet och skicka det till ",
		downloadcontract: "Ladda ner kontrakt",
		nousedtests: "Ingen använde {0} test",
		addanewtestadministrator: "Lägg till ny testadministratör",
		addlanguage: "Legg Til Språk",
		addtestadministrator: "Lägg till testadministratör",
		administrator: "Administratör",
		adultFollowup: "Adult Followup",
		adultFollowupLabel: "Adult-followup",
		adultScreeningLabel: "Adult-screening",
		adultTests: "Adult Tests",
		aktivLongText: "Har åtkomst till att skapa nya tester och se testresultat",
		aktivPrenumeration: "Aktiv Prenumeration",
		aktivitet: "Aktivitet",
		aldriFakturert: "Aldri fakturert",
		allTypes: "All types",
		allcountries: "Alle land",
		anvandarenArGodkandText: "Användaren är godkänd och ett e-postmeddelande har skickats med en inbjudan",
		approveuesr: "Godkjenn bruker",
		barnOgUngdomtester: "Barn och ungdomstester",
		barnOgVoksentester: "Barn och vuxentester",
		barnUngdomOgVoksentester: "Barn, ungdom och vuxentester",
		barnetester: "Barntester",
		basAbonLongText: "Har endast åtkomst till att se testresultat",
		basabonnemang: "Basabonnemang",
		basic: "Grundläggande",
		basicReverseCamel: "Basic",
		behoverGodkannande: "Behöver godkännande",
		blocked: "Blokkert",
		blockuser: "Blokker bruker",
		brukere: "Brukere",
		childFollowupLabel: "Child-followup",
		childScreeningLabel: "Child-screening",
		childTests: "Child Tests",
		copyemails: "Kopier e-post",
		costs: "Konstander",
		coststhismonth: "Kostnader denne måneden",
		createnewuser: "Skapa ny användare",
		currencysymbol: "SEK",
		currentstatus: "Nuvarande status:",
		deleatedat: "Slettet på",
		deleteOldTests: "Delete old and deleted tests",
		deleteuser: "Radera användare",
		deletedUser: "Deleted user",
		denneBrukHarAldriBlittFakturert: "Denne brukeren har aldri blitt fakturert",
		dysmateAFollowupLabel: "Dysmate-A-Followup",
		dysmateAFollowupText: "Dysmate-A-followup",
		dysmateAdultText: "Dysmate-adult",
		dysmateChildText: "Dysmate-child",
		dysmateYFollowupLabel: "Dysmate-Y-Followup",
		dysmateYFollowupText: "Dysmate-Y-followup",
		dysmateYouthText: "Dysmate-youth",
		edittestadministrator: "Ändra testadministratör",
		ejSlutfordRegistrering: "Ej slutförd registrering",
		exmapledemail: "ola@epost.no, eva@epost.no",
		exportmailingaddress: "Eksportér adresseliste",
		extendtrialperiod: "Utvid prøveperiode",
		fakturering: "Fakturering",
		fakturerteTester: "Fakturerte tester",
		fullSubText: "Full",
		fulltAbonnemang: "Aktiv Prenumeration",
		fulltAbonnement: "Fullt",
		gallerTill: "Gäller till {0}",
		inaktiv: "Inaktiv",
		inaktivLongText: "Har inte åtkomst till att skapa nya tester eller se testresultat",
		invoiced: "Invoiced",
		masteGodkannasAvAdmin: "Måste godkännas av administratör",
		message_notallowedemptysubscription: "Du kan ikke tildele et tomt abonnement! Slett språket i stedet.",
		message_nouserswiththestatus: "Ingen brukere med status {0}",
		mysubscription: "Min prenumeration",
		needsapproval: "Trenger godkjenning",
		newuser: "Ny Bruker",
		nonewusersduringtimeperiod: "Ingen nye kandidater i løpet av denne tidsperioden",
		normeringLongText: "Har åtkomst till att skapa normeringstester och se testresultat",
		normeringstester: "Normeringstester",
		normingAdultText: "Norming-adult",
		normingChildText: "Norming-child",
		normingYouthText: "Norming-youth",
		notInvoiced: "Icke fakturerad",
		notcompletedregistration: "Ikke fullført registrering",
		notestsafterdatetoinvoice: "Ingen tester etter valgte dato å fakturere",
		period: "Periode",
		previousperiods: "Tidligere perioder",
		priceandconditioninfo: ". Prisinformation och köpevillkor finns på ",
		prodNormingLongText: "Du har full åtkomst till att skapa nya tester och se testresultat",
		production: "Production",
		produksjonLongText: "Har åtkomst till att skapa tester och se testresultat",
		produksjonOgNormering: "Produktion & Normering",
		produksjonstester: "Produktionstester",
		proveperiode: "Provperiod",
		provperiodLongText: "Har endast åtkomst till totalt 8 tester",
		registrationURL: "Registration URL",
		registreringsnyckel: "Registreringsnyckel",
		savepermission: "save permission",
		savesubscription: "Spara prenumeration",
		select_users: "Velg brukere",
		selectedDate: "Selected date: ",
		sendInvoice: "Send invoice ➤",
		sendnewinvitation: "Send invitasjon på nytt",
		showearliermonths: "Se tidligere måneder ▼",
		sidenSistFakturert: "Siden sist fakturert",
		singleChild: "Barn",
		sistFakturertPa: "Sist fakturert på",
		skjult: "Skjult",
		slettetBruker: "Slettet bruker",
		subscription: "Prenumeration",
		subscriptionAdultFollowup: "Adult Followup",
		subscriptionAdultTests: "Adult Tests",
		subscriptionChildFollowup: "Child Followup",
		subscriptionChildTests: "Child Tests",
		subscriptionNorming: "Norming",
		subscriptionYouthFollowup: "Youth Followup",
		subscriptionYouthTests: "Youth Tests",
		superHandelser: "Super hendelser",
		supersubscription: "Har prenumeration",
		testHandelser: "Test hendelser",
		teststhismonths: "Tester denne måneden",
		totalnew: "Nye/Totalt",
		totaltTester: "Totalt tester",
		ufakturerteTester: "Ufakturerte tester",
		unblockuser: "Ublokker bruker",
		underUtviklingInvoices: "Under utvikling Invoices...",
		ungdomOgVoksentester: "Ungdom och vuxentester",
		ungdomstester: "Ungdomstester",
		userHandelser: "User hendelser",
		users: "Användare",
		usersLoggedOutForcefully: "Users logged out forcefully!",
		usersUnblockedSuccessfully: "Users unblocked successfully!",
		utlopteDen: "Utløpte den {0}",
		valgtEpost: "Valt e-postadress",
		viewsubscription: "Se prenumeration ▼",
		voksentester: "Vuxentester",
		warning_blockuser: "Er du sikker på at du vil blokkere valgte bruker?",
		warning_deleteLanguage: "Er du sikker på at du vil slette dette språken?",
		warning_unblockuser: "Er du sikker på at du vil ublokkere valgte bruker?",
		youthFollowup: "Youth Followup",
		youthFollowupLabel: "Youth-followup",
		youthScreeningLabel: "Youth-screening",
		youthTests: "Youth Tests",
		selected_users: "Välj användare",
	},

	// ===================================================================
	// controlPanel
	// ===================================================================
	controlPanel: {
		allnotifications: "Alla aviseringar",
		aviseringarTab: "Aviseringar",
		configAddMissingPlaceholders: "Add missing placeholders: {0}",
		configAllaOption: "Alla",
		configBelongsHere: " belongs here: ",
		configCacheNote: "Changes visible to all users within 5 minutes (cache TTL)",
		configCancel: "Cancel",
		configCannotSaveWarning: "⚠ Cannot save — add the missing placeholder(s) back:",
		configDefaultLabel: "Default:",
		configEditTitle: "Edit",
		configEditedBy: " by ",
		configKeyHeader: "Key",
		configKeysFound: "{0} keys found",
		configKeysSummary: "{0} keys · {1} overridden",
		configLastEdited: "Last edited: ",
		configNoKeysMatch: "No keys match your search.",
		configNoOverriddenKeys: "No overridden keys for {0} yet.",
		configOverriddenBadge: "overridden",
		configOverriddenOption: "Overridden",
		configRequiredPlaceholders: "Required placeholders: ",
		configResetToDefault: "Reset to default",
		configSaveLabel: "Save",
		configSavedConfirm: "Saved ✓",
		configSavingLabel: "Saving...",
		configSearchPlaceholder: "Search key...",
		configValueHeader: "Value",
		configurations: "Strings Configuration",
		createANotification: "Create a notification",
		createNotification: "Opprett et varsling",
		createSePayload: "Create SE payload",
		createdOn: "Opprettet kl",
		createnotificationwarning: "Du kan inte ändra meddelandet när det väl har lagts upp",
		deleteNotification: "Delete Notification",
		editNotification: "Edit Notification",
		erDuSikkerVilSletteVarslinget: "Er du sikker på at du vil slette dette varslinget?",
		kontrollpanel: "Kontrollpanel",
		nonotificationsfound: "Inga varningar hittades",
		notificationcreated: "Varning skapad",
		postNotification: "Post Notification",
		scheduleNotification: "Schedule a Notification",
		seNormingTests: "SE Norming Tests",
		sendPayload: "Send payload",
		simulateForeign: "Foreign language background",
		simulateForeignNo: "No",
		simulateForeignYes: "Yes",
		simulateGender: "Gender",
		simulateGenderFemale: "Female",
		simulateGenderMale: "Male",
		simulateGenericError: "An error occurred while simulating the test result.",
		simulateGrade: "Grade",
		simulateResults: "Simulera Resultat",
		simulateResultsHeading: "Simulated Results",
		simulateSelect: "-- Select --",
		simulateSelectGender: "-- Select gender --",
		simulateSelectGrade: "-- Select grade --",
		simulateSubmit: "Simulate",
		simulateSubmitting: "Simulating...",
		simulateSubtest1: "Word Dictation",
		simulateSubtest2: "Word Chain",
		simulateSubtest3: "Swap Soundtest",
		simulateSubtest4: "Writing Efficiency",
		simulateSubtest5: "Reading Comprehension",
		simulateSubtest6: "Word Comprehension",
		simulateSubtestsHeading: "Subtest Scores",
		simulateTestType: "Test type",
		simulateTestTypeValue: "Child Screening (SE)",
		sweidshTestKeys: "Swedish Test Keys",
		testerTab: "Tester",
		viewNotification: "Se varslinger",
		writeYourContent: "Write your content ....",
	},

	// ===================================================================
	// calendar
	// ===================================================================
	calendar: {
		april: "april",
		august: "augusti",
		december: "december",
		dutch: "Nederländska",
		england: "Storbritannien",
		english: "Engelska",
		february: "februari",
		german: "Tyska",
		germany: "Tyskland",
		january: "januari",
		juli: "juli",
		june: "juni",
		march: "mars",
		may: "maj",
		nederland: "Nederländerna",
		norway: "Norge",
		norwegian: "Norska",
		november: "november",
		october: "oktober",
		september: "september",
		sweden: "Sverige",
		swedish: "Svenska",
	},

	// ===================================================================
	// pronouns
	// ===================================================================
	pronouns: {
		pronounHan: "han",
		pronounHen: "hen",
		pronounHon: "hon",
	},
};
